import { useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { Queries } from '@shared/api';

export function useEntityBatch(entityBatchId?: string, workflowTemplateId?: string) {
  return useQuery<
    MBAPI.GetRecurringEntitiesScheduleQuery,
    MBAPI.GetRecurringEntitiesScheduleQueryVariables
  >(Queries.entity.getRecurringEntitiesSchedule, {
    variables: { input: { id: entityBatchId ?? '', workflowTemplateId: workflowTemplateId ?? '' } },
    skip: isNil(entityBatchId) || isNil(workflowTemplateId),
  });
}
